let events = [];
let confirmClose = false;

function handleBeforeunload(event) {
  const e = event || window.event;
  if (events.length > 0 || confirmClose) {
    e.preventDefault();
  }

  events.forEach(callback => callback.listener());

  if (confirmClose) {
    if (e) {
      e.returnValue = "";
    }
    return '';
  }
}

export const BeforeOnload = {
  init() {
    window.addEventListener('beforeunload', handleBeforeunload);
  },
  destroy() {
    window.removeEventListener('beforeunload', handleBeforeunload);
  },
  confirmClose() {
    confirmClose = true;
  },
  noConfirmClose() {
    confirmClose = false;
  },
  on(eventName, listener) {
    events.push({listener: listener, eventName: eventName});
  },
  off(eventName, listener) {
    const newEvents = [];
    events.forEach(callback => {
      if (callback['eventName'] !== eventName) newEvents.push(callback);
    });
    events = newEvents;
  },
};



// WEBPACK FOOTER //
// ./src/util/beforeOnload.js